import type { HandbookResponse } from '../types/handbook';
import { API_URLS_LIST } from '../config';
import { apiService } from './apiService';

export const handbookRequest = apiService.createGetMethod<
  undefined,
  HandbookResponse
>(API_URLS_LIST.handbook);
